import { Box, styled } from '@mui/material';

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
`;

export default Container;
